import { Calendar } from "@/Calendar";
import { Dialog } from "@/Dialog";
import { ValidateSelect } from "@/Select";
import { SequentialAnimation } from "@/SequentialAnimation";
// import { useStorage } from "@/useStorage";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useState } from "react";
import { useForm } from "react-hook-form";

export const Route = createFileRoute("/customer/layout/to-school")({
  component: ToSchool,
});

function ToSchool() {
  const [visible, setVisible] = useState(false);
  // const [storage, setStorage] = useStorage<string>("title");
  const { history } = useRouter();

  const handleGo = () => {
    history.push("/payment/test");
  };
  const options = [
    { value: "hhh1", label: "2" },
    {
      value: "4",
      label: "dgdrga",
    },
  ];
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ abc: string[]; b: string }>({
    defaultValues: {
      b: "c",
    },
  });
  const onSubmit = (d: unknown) => {
    console.log(d);
  };
  return (
    <form className="p-2" onSubmit={handleSubmit(onSubmit)}>
      <SequentialAnimation>
        {/* <h3 onClick={() => setStorage("dawd11")}>{storage}dawdawd</h3>
        <h3 onClick={() => setVisible(true)}>
          {storage}dawdawdawdawdkal;wd;klaw1
        </h3> */}
        <Dialog visible={visible}>
          <p onClick={() => setVisible(false)}>234234234</p>
        </Dialog>
        <Calendar />
        <input type="text" {...register("b")} />

        <ValidateSelect
          options={options}
          errorMessage={errors?.abc?.message}
          defaultValues={["4"]}
        />

        <button>교교</button>
        <button type="button" onClick={handleGo}>
          dd
        </button>
      </SequentialAnimation>
    </form>
  );
}
